// import constants from '@/core/constants'

const state = {
  searchFilters: {
    propertyManagerFilter: '*',
    caseStatus: null,
    workTypes: [],
    searchText: ''
  }
}

const actions = {
  setSearchFilters({ commit }, payload) {
    commit('set_filters', payload)
  }
}

const mutations = {
  set_filters(state, payload) {
    state.searchFilters[payload.key] = payload.value
  }
}

const getters = {
  searchText: (state) => state.searchText,
  searchFilters: (state) => state.searchFilters
}

export default {
  state,
  actions,
  mutations,
  getters
}
